import CheckBox from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlank from "@material-ui/icons/CheckBoxOutlineBlank";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useHistory, useLocation } from "react-router-dom";
import "../../../customStyles/bootstrap_table.css";
import { OFFER_STATUS } from "../../../utils/constants";

const { SearchBar, ClearSearchButton } = Search;

export const buttonsStyle = {
	maxWidth: "30px",
	maxHeight: "30px",
	minWidth: "30px",
	minHeight: "30px",
	marginLeft: "1em",
};

export function booleanFormatter(cell) {
	return cell ? (
		<CheckBox style={{ color: "#D91E48" }} />
	) : (
		<CheckBoxOutlineBlank style={{ color: "#D91E48" }} />
	);
}

export function longTextFormatter(cell) {
	return (
		<td className="truncate">
			<div dangerouslySetInnerHTML={{ __html: cell }}></div>
		</td>
	);
}

function extractContent(s) {
	if (!s) return "----";
	var span = document.createElement("span");
	span.innerHTML = s;
	return span.textContent || span.innerText;
}

export function substringFormatter(cell) {
	const text = extractContent(cell);
	return text.length > 50 ? text.substring(0, 50) + "..." : text;
}

const buildDate = (date) => {
	if (Object.prototype.toString.call(date) !== "[object Date]") return;
	const displayDate = `${date.getDate()}/${date.getMonth() +
		1}/${date.getFullYear()}  ${date.getHours()}:${String(
		date.getMinutes()
	).padStart(2, "0")}`;
	return displayDate;
};

export function dateFormatter(cell) {
	let date = new Date(cell);
	const localDate = new Date(
		date.getTime() - date.getTimezoneOffset() * 60000
	);

	const formattedDate = buildDate(localDate);

	return formattedDate;
}

export function getOfferStatusAppearance(offerStatus) {
	const normalizedDescription =
		offerStatus?.descripcion?.trim().toLowerCase() || "";
	const isRejectedStatus =
		normalizedDescription === "denegada" ||
		normalizedDescription === "cancelada";
	return {
		className:
			offerStatus?.id === OFFER_STATUS.BORRADOR
				? "bg-warning text-white"
				: offerStatus?.id === OFFER_STATUS.PRESENTADA
				? "bg-info text-white"
				: offerStatus?.id === OFFER_STATUS.APROBADA
				? "bg-success text-white"
				: "",
		style: {
			backgroundColor: isRejectedStatus ? "#f8d7da" : undefined,
			color: isRejectedStatus ? "#842029" : undefined,
		},
	};
}

export function offerStatusFormatter(offerStatus) {
	const appearance = getOfferStatusAppearance(offerStatus);

	return (
		<div
			className={`${appearance.className} p-2`}
			style={{
				borderRadius: "0.42rem",
				...appearance.style,
			}}
		>
			{offerStatus?.descripcion?.toUpperCase()}
		</div>
	);
}

const customTotal = (from, to, size) => (
	<span
		className="react-bootstrap-table-pagination-total"
		style={{ paddingLeft: "5px" }}
	>
		Mostrando {from}-{to} de {size} resultados
	</span>
);

export function getCurrentTablePage(location) {
	const searchParams = new URLSearchParams(location?.search);
	return parseInt(searchParams?.get("page"));
}

const rowClasses = (row) => {
	if (!row || typeof row !== "object") return "";
	return row.activo === false || row.active === false ? "inactive-row" : "";
};

export default function Table({
	data,
	columns,
	rowEvents,
	persistPageInUrl = true,
	pageResetKey,
	hideSearch = false,
	...tableProps
}) {
	const history = useHistory();
	const location = useLocation();
	const [localPage, setLocalPage] = React.useState(1);
	React.useEffect(() => {
		if (!persistPageInUrl) setLocalPage(1);
	}, [pageResetKey, persistPageInUrl]);

	const page = persistPageInUrl ? getCurrentTablePage(location) : localPage;
	const safeData = Array.isArray(data) ? data.filter(Boolean) : [];

	const pagination = paginationFactory({
		page: page || 1,
		sizePerPage: 50,
sizePerPageList: [
  { text: "25", value: 25 },
  { text: "50", value: 50 },
  { text: "100", value: 100 },
  { text: "200", value: 200 },
],
		lastPageText: ">>",
		firstPageText: "<<",
		nextPageText: ">",
		prePageText: "<",
		showTotal: true,
		paginationTotalRenderer: customTotal,
		alwaysShowAllBtns: false,
		onPageChange: function(page, sizePerPage) {
			if (persistPageInUrl) {
				history.push(`?page=${page}`);
			} else {
				setLocalPage(page);
			}
		},
		onSizePerPageChange: function(page, sizePerPage) {},
	});

	return (
		<ToolkitProvider
			bootstrap4
			keyField="id"
			data={safeData}
			columns={columns}
			search={!hideSearch}
		>
			{(props) => (
				<div>
					{!hideSearch && (
						<>
							<SearchBar placeholder="Buscar" {...props.searchProps} />
							<ClearSearchButton
								className="ml-3"
								{...props.searchProps}
							/>
							<br />
							<br />
						</>
					)}
					<BootstrapTable
						wrapperClasses=""
						classes="table table-head-custom table-vertical-center"
						bordered={false}
						pagination={pagination}
						striped
						rowClasses={rowClasses}
						rowEvents={rowEvents}
						{...tableProps}
						{...props.baseProps}
					/>
				</div>
			)}
		</ToolkitProvider>
	);
}
